module.exports = __webpack_public_path__ + "img/187.e55b2009.jpg";